import { render, staticRenderFns } from "./HeaderDashbord.vue?vue&type=template&id=7531afac&scoped=true&"
import script from "./HeaderDashbord.vue?vue&type=script&lang=js&"
export * from "./HeaderDashbord.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDashbord.vue?vue&type=style&index=0&id=7531afac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7531afac",
  null
  
)

export default component.exports